// 9fbef606107a605d69c0edbcd8029e5d
import { DASHBOARD_ORDERS_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';

const getState = (state) => state[DASHBOARD_ORDERS_REDUCER_KEY];

export const getOrderByShipmentFetchingState = (state) => {
  return getState(state)?.get('isFetching');
};

export const getOrdersByShipmentFormatted = (state) => {
  return getState(state)?.get('ordersByShipment');
};
